import { API } from "aws-amplify";
import { UpdateAlertCutoffEventBody, UpdateSettingsEventBody } from 'src/types/index';

export async function updateAlertCutoff(monitorId: number, cutoff: number) {
    const body: UpdateAlertCutoffEventBody = {value: cutoff};
    try {
      const res: any = await API.put("data", `/data/cutoff/${monitorId.toString()}`, {
        body,
      });
      return res;
    } catch(e) {
      console.log(e)
    }
  }

export async function updateSettings(settings: any[]) {
    const email = localStorage.getItem("username") ? localStorage.getItem("username") : null;
    if(email) {
        const body: UpdateSettingsEventBody = {
            email,
            settings,
        };
        try {
        const res: any = await API.post("data", `/data/users/settings`, {
            body,
        });
        return res;
        } catch(e) {
        console.log(e)
        }
    } else return "invalid email"
  }



// WEBPACK FOOTER //
// ./src/libs/update-lib.ts